import React from "react";
import { Box, Button, Badge, Divider, Skeleton } from "@mui/material";

const AudioCategoryListLoading = () => {
    const skeletonStyles = {
        backgroundColor: "white",
        color: "white", // Set the text color to white
      };

  const skeletonItems = Array.from({ length: 13 }, (_, index) => (
    <React.Fragment key={index}>
      <Box className="py-4 flex justify-between">
        <Button variant="default">
          <Skeleton variant="text" width={170} height={35} sx={{...skeletonStyles}} />
        </Button>
        <Badge color="secondary" overlap="circular" className="mr-4">
          <Skeleton variant="circle" width={30} height={30} sx={{...skeletonStyles, borderRadius: '50%'}} />
        </Badge>
      </Box>
      <Divider variant="middle" sx={{ backgroundColor: "#52525b" }} />
    </React.Fragment>
  ));

  return <Box>{skeletonItems}</Box>;
};

export default AudioCategoryListLoading;
